import { Spin } from "antd";
import React, { Suspense } from "react";
import { AuthenticationWrap } from "./style";

const goBack = () => {
  window.location.reload();
};
const RspLayout = (WraperContent) => {
  console.log("window.innerWidth-----", window.innerWidth, window.innerHeight);
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  let bgUrl = "rspbg.jpg";
  if (screenWidth < 821) {
    bgUrl = "rspbg-port";
  }
  return function () {
    return (
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        <AuthenticationWrap
          className={screenWidth < 821 ? "rspPort" : "rspHorz"}
          style={{
            backgroundImage:
              screenWidth < 821
                ? `url("${require("../../../static/img/rsp/rspbg-port.jpg")}")`
                : `url("${require("../../../static/img/rsp/rspbg.jpg")}")`,
          }}
        >
          <div className="ninjadash-authentication-wrap">
            <WraperContent />
          </div>
        </AuthenticationWrap>
      </Suspense>
    );
  };
};

export default RspLayout;
